import getCurrency from '~/lib/get-currency'

import useLocale from '~/hooks/useLocale'

export default function useCurrency() {
  const locale = useLocale()
  return getCurrency(locale)
}
